import React from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';
import { composeInterpretation } from './utils/interpretationTemplates';
import { isQ3Enabled } from './utils/featureFlags';

const Section = styled.section`
  max-width: 560px;
  margin: ${p => p.theme.spacing[4]}px auto 0;
  padding: ${p => p.theme.spacing[4]}px;
  background: linear-gradient(180deg, rgba(255, 251, 240, 0.8), rgba(255, 243, 214, 0.6));
  border: 1px solid rgba(218, 165, 32, 0.3);
  border-radius: 12px;
  text-align: left;
`;

const Heading = styled.h3`
  font-family: 'Noto Sans Tamil', 'Playfair Display', serif;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #8B6914;
  margin: 0 0 ${p => p.theme.spacing[3]}px;
  text-align: center;
`;

const Paragraph = styled.p`
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
  font-size: 15px;
  line-height: 1.7;
  color: #2C1810;
  margin: 0 0 ${p => p.theme.spacing[3]}px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const PanchangaInterpretation = ({ snapshot, verseTone = 'mixed', lang = 'en' }) => {
  const locale = useLocale(lang, 'prashnavali');
  const t = (locale && locale.panchangam) || {};

  if (!isQ3Enabled() || !snapshot) return null;

  const { opening, middle, closing } = composeInterpretation(snapshot, verseTone, lang);
  if (!opening && !middle && !closing) return null;

  return (
    <Section aria-label={t.insightHeading}>
      <Heading>{t.insightHeading}</Heading>
      {opening && <Paragraph>{opening}</Paragraph>}
      {middle && <Paragraph>{middle}</Paragraph>}
      {closing && <Paragraph>{closing}</Paragraph>}
    </Section>
  );
};

export default PanchangaInterpretation;
